<template>
  <div class="content">
    <div class="page-inner">
      <div class="card">
        <div class="card-body">
          <section class="scrollable mb-lg-4">
            <section class="p-1 mb-lg-4">
              <h1 class="text-dark strong mb-4 mt-2">{{ $t('i_want_to_creat') }}</h1>
              <div class="row mt-2 justify-content-center">
                <div class="col-md-4 col-xs-4 col-sm-4 mb-2">
                  <button type="button" class="btn btn-block box-shadow" @click="campaign.type = 'spotify_follow_artist'" :class="{ 'btn-primary strong': campaign.type === 'spotify_follow_artist', 'bg-light': campaign.type !== 'spotify_follow_artist' }">
                    <div class="mt-5 h1 strong text-success">Spotify</div>
                    <div class="h2 mb-5">{{ $t('artist_campaign') }}</div>
                  </button>
                </div>
                <div class="col-md-4 col-xs-4 col-sm-4 mb-2">
                  <button type="button" class="btn btn-block box-shadow" @click="campaign.type = 'spotify_follow_playlist'" :class="{ 'btn-primary strong': campaign.type === 'spotify_follow_playlist', 'bg-light': campaign.type !== 'spotify_follow_playlist' }">
                    <div class="mt-5 h1 strong text-success">Spotify</div>
                    <div class="h2 mb-5">{{ $t('playlist_campaign') }}</div>
                  </button>
                </div>
                <!-- <div class="col-md-4 col-xs-4 col-sm-4 mb-2">
                  <button type="button" class="btn btn-block box-shadow" @click="campaign.type = 'youtube_sub'" :class="{ 'btn-primary strong': campaign.type === 'youtube_sub', 'bg-light': campaign.type !== 'youtube_sub' }">
                    <div class="mt-5 h1 strong text-danger">Youtube</div>
                    <div class="h2 mb-5">{{ $t('campaign') }}</div>
                  </button>
                </div> -->
              </div>
              <form class="form mb-lg-4" @submit.prevent="createCampaign">
                <div class="form-group mt-5">
                  <div v-show="artists.length">
                    <label>{{ $t('artist') }}:</label>
                    <select class="form-control" v-model="campaign.artist" @change="updateCampaign(true)" :required="artists.length ? true : false" v-show="artists.length">
                      <option value="">{{ $t('select_artist') }}</option>
                      <option :value="artist._id" v-for="artist in artists" v-bind:key="artist._id">
                        {{ artist.name }}
                      </option>
                    </select>
                  </div>
                  <p v-if="!artists.length" class="alert alert-info mt-2 p-3" v-html="$t('no_artists_yet')"></p>
                </div>
                <div class="form-group">
                  <label>{{ $t('artist_profile_enter_valid_url') }}</label>
                  <input v-model="campaign.url" type="url" class="form-control" placeholder="URL">
                  <div v-if="campaign.url" class="mt-2">
                    <span class="text-primary">{{ $t('verify_link') }}</span>: <a class="ml-1" :href="campaign.url" target="_blank">{{ $t('open_new_window') }} <i class="fa fa-external-link-alt"></i></a>
                  </div>
                  <!-- <div class="mt-2 alert alert-danger wrapper-xs" v-if="campaign.type === 'youtube_sub' && campaign.url && !campaign.url.match(/channel/)">
                    {{ $t('invalid_channel_link') }}: <br/>
                    <a href="https://www.youtube.com/channel/UCoamjs_-CxpbOdDO3t8fWWQ" target="_blank">https://www.youtube.com/channel/UCoamjs_-CxpbOdDO3t8fWWQ</a>
                  </div> -->
                  <div class="mt-2 alert alert-danger wrapper-xs" v-if="campaign.type === 'spotify_follow_artist' && campaign.url && !campaign.url.match(/open\.spotify.com\/artist\//)">
                    {{ $t('invalid_channel_link') }}: <br/>
                    <a href="https://open.spotify.com/artist/47DPmCJZz8t7IodbxDVacZ" target="_blank">https://open.spotify.com/artist/47DPmCJZz8t7IodbxDVacZ</a>
                  </div>
                  <div class="mt-2 alert alert-danger wrapper-xs" v-if="campaign.type === 'spotify_follow_playlist' && campaign.url && !campaign.url.match(/playlist\//)">
                    {{ $t('invalid_channel_link') }}: <br/>
                    <a href="https://open.spotify.com/user/0prvlevxuj0z0qizh2o7zd5hy/playlist/4upW6GXuE1Cqzok1fnkOIN?si=Xvjv-FeNTLGe32yczJa9OQ" target="_blank">https://open.spotify.com/user/0prvlevxuj0z0qizh2o7zd5hy/playlist/4upW6GXuE1Cqzok1fnkOIN?si=Xvjv-FeNTLGe32yczJa9OQ</a>
                  </div>
                </div>
                <div class="form-group">
                  <label>What is your main genre?</label>
                  <select class="form-control" v-model="campaign.main_genre" @change="updateCampaign()">
                    <option value="">{{ $t('genre') }}</option>
                    <option :value="genre" v-for="genre in genres" v-bind:key="genre">
                      {{ genre }}
                    </option>
                  </select>
                </div>
                <hr>
                <div class="form-group mt-4">
                  <div class="h3 strong text-dark">{{ $t('customize_campaign') }}</div>
                  <div>
                    {{ $t('you_have') }} <span class="text-warning strong">{{ credits }} {{ $t('credits') }}</span>
                  </div>
                </div>
                <div class="form-group">
                  <div>
                    <span class="h4 text-dark strong">
                      {{ $t('credits_to_spend') }} <span class="text-primary">{{ $t('min_credits') }}</span>
                    </span>
                  </div>
                  <input class="form-control mt-2 col-xs-4 col-sm-4 col-md-4" v-model="campaign.credits" type="number" min="25" @change="validateCredits()">
                </div>
                <div class="form-group mt-4">
                  <label class="h4 strong text-dark">{{ $t('how_many_you_give') }}</label>
                  <div class="row mt-2">
                    <div class="col-md-2 col-xs-4 col-sm-4 mb-2">
                      <button type="button" class="btn btn-block" @click="campaign.cpc = 1" :class="{ 'btn-primary strong': campaign.cpc === 1, 'bg-light': campaign.cpc !== 1 }">1</button>
                    </div>
                    <div class="col-md-2 col-xs-4 col-sm-4 mb-2">
                      <button type="button" class="btn btn-block" @click="campaign.cpc = 3" :class="{ 'btn-primary strong': campaign.cpc === 3, 'bg-light': campaign.cpc !== 3 }">3</button>
                    </div>
                    <div class="col-md-2 col-xs-4 col-sm-4 mb-2">
                      <button type="button" class="btn btn-block" @click="campaign.cpc = 5" :class="{ 'btn-primary strong': campaign.cpc === 5, 'bg-light': campaign.cpc !== 5 }">5</button>
                    </div>
                  </div>
                </div>
                <div class="form-group mt-4">
                  <span class="h3 text-dark strong">{{ $t('credits_needed_campaign') }} <span class="text-primary">{{ getCampaignCredits() }}</span></span>
                  <p class="strong text-dark-dk">
                    {{ $t('please_review') }}
                  </p>
                </div>
                <div class="form-group mt-2">
                  <button v-bind:disabled="!campaign.credits || creating" type="submit" class="btn btn-primary btn-lg mt-3 col-xs-12 col-lg-4 col-xl-4 col-md-4">{{ $t('create_campaign') }}</button>
                </div>
              </form>
            </section>
            <div class="mb-lg-4 mt-4 wrapper-lg"></div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import genres from '../data/genres'
// import _ from 'lodash'
import _ from 'underscore'

export default {
  data: function () {
    return {
      user: {},
      genres: _.map(genres, (genre, key) => {
        return key
      }),
      creating: false,
      credits: 0,
      selectedArtist: null,
      campaign: {
        type: 'spotify_follow_artist',
        artist: '',
        credits: 25,
        cpc: 1,
        url: '',
        main_genre: ''
      },
      artists: [],
      loading: true,
      campaignOptions: [
        {
          id: 'spotify_follow_artist',
          name: 'Spotify',
          text: 'Artist campaign',
          color: 'success'
        },
        {
          id: 'spotify_follow_playlist',
          name: 'Spotify',
          text: 'Playlist campaign',
          color: 'success'
        },
        {
          id: 'youtube_sub',
          name: 'Youtube',
          text: 'campaign',
          color: 'danger'
        }
      ],
      selectedCampaign: null
    }
  },
  methods: {
    getCampaignCredits () {
      let credits = this.campaign.credits

      return credits
    },
    createCampaign () {
      let creditsNeeded = parseInt(this.campaign.credits, 10)

      if (!this.campaign.type) {
        return this.$notify({ message: this.$t('please_select_type') }, 'warning', 'fa-exclamation')
      }

      if (this.campaign.credits < 25) {
        return this.$notify({ message: this.$t('mimimum_is_25') }, 'warning', 'fa-exclamation')
      }

      if (creditsNeeded > this.credits) {
        return this.$notify({ message: this.$t('no_enough_credits_to_create') }, 'warning', 'fa-exclamation')
      }

      if (this.campaign.cpc > creditsNeeded) {
        return this.$notify({ message: this.$t('no_enough_cpc') }, 'warning', 'fa-exclamation')
      }

      if (!this.campaign.credits) {
        return
      }

      if (!this.campaign.url) {
        return
      }

      if (!this.campaign.main_genre) {
        return
      }

      if (!this.campaign.type) {
        return
      }

      if (this.campaign.type === 'youtube_sub' && !this.campaign.url.match(/channel/)) {
        return
      }

      if (this.campaign.type === 'spotify_follow_artist' && !this.campaign.url.match(/open\.spotify\.com\/artist\//)) {
        window.swal({
          title: this.$t('incorrect_url'),
          text: this.$t('check_example_url'),
          closeOnEsc: false,
          closeOnClickOutside: false,
          icon: 'warning'
        })
        return
      }

      if (this.campaign.type === 'spotify_follow_playlist' && !this.campaign.url.match(/playlist\//)) {
        return
      }

      if (this.campaign.url.match(/undefined/)) {
        return
      }

      this.creating = true

      this.$http.post(`${window.apiURL}api/user/campaigns`, this.campaign, { withCredentials: true }).then(response => {
        this.$eventBus.$emit('updateCredits')
        this.$router.push('/user/campaigns')
        this.$notify({ message: this.$t('campaign_created') }, 'success', 'fa-check')
      }, (err, response) => {
        console.log('Error creating campaign', err)
        this.creating = false
        this.$notify({ message: this.$t('campaign_url_used') }, 'danger', 'fa-exclamation')
      })
    },
    validateCredits () {
      if (this.campaign.credits > this.credits) {
        this.campaign.credits = this.credits
      }
    },
    updateCampaign (artistChanged) {
      this.selectedArtist = _.find(this.artists, artist => artist._id === this.campaign.artist) || {}

      if (artistChanged && this.selectedArtist.main_genre) {
        this.campaign.main_genre = this.selectedArtist.main_genre
      }

      switch (this.campaign.type) {
        case 'facebook_follow':
          this.campaign.url = this.selectedArtist.facebook || ''
          break

        case 'spotify_follow_artist':
          if (this.selectedArtist.spotify_id) {
            this.campaign.url = `https://open.spotify.com/artist/${this.selectedArtist.spotify_id}`
          }
          break

        case 'spotify_follow_playlist':
          this.campaign.url = ''
          break

        // case 'youtube_sub':
        //   this.campaign.url = this.selectedArtist.youtube || ''
        //   break

        case 'soundcloud_follow':
          this.campaign.url = this.selectedArtist.soundcloud || ''
          break
      }
    }
  },
  created () {
    this.$http.get(`${window.apiURL}api/user/credits`, { withCredentials: true }).then(response => {
      this.credits = response.data.available || 0
    })

    this.$http.get(`${window.apiURL}api/user/artists`, { withCredentials: true }).then(response => {
      this.artists = response.data

      if (this.artists[0]) {
        this.campaign.artist = this.artists[0]._id
        this.updateCampaign(true)
      }
    }, () => {})

    if (localStorage.getItem('user')) {
      try {
        this.user = JSON.parse(localStorage.getItem('user'))
      } catch (e) {}
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/CreateCampaign.vue